<app-workflow-step-layout [infoWidth]="'50rem'" [readOnly]="readOnly">
  <ng-container info>
    <div class="info-container">
      <!-- readonly relevant fields -->
      <ng-container *ngIf="readOnly">
        <!-- batches -->
        <h3>Verwendete Chargen</h3>
        <app-batches-selector
          [readOnly]="true"
          [forms]="batchFormArray">
        </app-batches-selector>

        <h3>Verwendete statische Werte</h3>
        <div class="data-row">
          <div>Umrechnungsfaktor</div>
          <div>{{workflowStep.factorStandard | number: '1.3-3'}}</div>
        </div>

        <h3>Verwendete Formeln</h3>

        <div>µL Volumen = (Zielkonzentration * Gesamtvolumen) / ( Konzentration * Umrechnungsfaktor)</div>
        <div>µL Wasser = Gesamtvolumen - Summe(µL Volumen)</div>
        <h3>
          Die Indexpools A, B, C, D wurden vereint.
        </h3>
      </ng-container>

      <ng-container *ngIf="!readOnly">
        <div *ngIf="batchFormArray">
          <ng-container *ngFor="let batchFormGroup of batchFormArray.controls">
            <app-batch-selector
              [readOnly]="readOnly"
              [form]="getFormGroupFromAbstractControl(batchFormGroup)"
              (onChange)="validateStep()"
              [showExpirationDate]="false">
            </app-batch-selector>
          </ng-container>
        </div>

        <h3>Formeln</h3>

        <div>µL Volumen = (Zielkonzentration * Gesamtvolumen) / ( Konzentration * Umrechnungsfaktor)</div>
        <div>µL Wasser = Gesamtvolumen - Summe(µL Volumen)</div>

        <div class="confirm-index-pool-combined">
          <h3>Indexpools A, B, C, D vereint?</h3>
          <core-button
            [width]="'100%'"
            [text]="'Bestätigen'"
            classList="p-button-success"
            [disabled]="workflowStep.indexPoolsCombined || readOnly"
            (onClick)="onIndexPoolCombined()">
          </core-button>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <ng-container plate>
    <div class="pooling-container">
      <div class="params-info-row">
        <div class="param-item">
          <span class="param-label">Volumen / Pool:</span>
          <span class="param-value">{{workflowStep.volumeForFourNmPool | number: '1.1-1'}} [µl]</span>
        </div>
        <div class="param-item">
          <span class="param-label">Zielkonzentration:</span>
          <span class="param-value">{{workflowStep.targetConcentration | number: '1.1-1'}} [nM]</span>
        </div>
      </div>

      <table class="pooling-table">
        <thead>
        <tr>
          <th>Pool</th>
          <th>Messung 1 [ng/µl]</th>
          <th>Messung 2 [ng/µl]</th>
          <th>Mittelwert [ng/µl]</th>
          <th>Volumen [µl]</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let group of concentrationForm.controls; let i = index" [formGroup]="getFormGroupFromAbstractControl(group)">
          <td>Pool {{getPoolLabel(i)}}</td>
          <td>
            <core-input-number
              *ngIf="!readOnly"
              [formControlName]="CONCENTRATION_1"
              [required]="true"
              [removeDefaultBottomErrorMargin]="true"
              [maxFractionDigits]="2"
              [showClearButton]="false">
            </core-input-number>
            <span *ngIf="readOnly">{{group.get(CONCENTRATION_1).value | number: '1.2-2'}}</span>
          </td>
          <td>
            <core-input-number
              *ngIf="!readOnly"
              [formControlName]="CONCENTRATION_2"
              [required]="true"
              [removeDefaultBottomErrorMargin]="true"
              [maxFractionDigits]="2"
              [showClearButton]="false">
            </core-input-number>
            <span *ngIf="readOnly">{{group.get(CONCENTRATION_2).value | number: '1.2-2'}}</span>
          </td>
          <td>
            <span>{{group.get(CONCENTRATION).value | number: '1.2-2'}}</span>
          </td>
          <td>{{group.get(DILUTION).value | number: '1.2-2'}}</td>
        </tr>
        <tr class="water-row">
          <td colspan="4">Resuspension Buffer (RSB)</td>
          <td>{{getTotalWater() | number: '1.2-2'}}</td>
        </tr>
        <tr class="total-row">
          <td colspan="4">Gesamtvolumen A–D</td>
          <td>{{getTotalVolume() | number: '1.2-2'}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</app-workflow-step-layout>
